import { findIndex } from 'lodash-es';
import { useEffect, useRef } from 'react';
import { meeting, speakWeight } from '@/models';
import { nowSpeakInOnePage } from '@/utils/common';

export const useSwapSpeakWeight = () => {
  const calcNowBiggerWeight = useRef<any>();
  const swapMembersByWeight = (yuxid: string) => {
    if (meeting?.sortMembers) {
      const members = meeting?.sortMembers;
      const yuxidIndex = findIndex(members, (item) => {
        return item.yxUidStr === yuxid;
      });
      const firstPageMembers = members?.slice(0, 9);

      const excludePreviousMembers = firstPageMembers.filter(
        (item) => item.yxUidStr !== speakWeight?.previousSpeakYuxid
      );

      let firstPageLessWeightYuxid: string | undefined,
        minTotalWeight: number | undefined,
        firstPageLessWeightIndex: number | undefined;

      const firstUserWeight = speakWeight.userWeightMap.get(excludePreviousMembers[0].yxUidStr!);
      minTotalWeight = firstUserWeight?.totalWeight;
      for (let i = 0; i < excludePreviousMembers.length; i++) {
        const userWeight = speakWeight.userWeightMap.get(
          excludePreviousMembers[i].yxUidStr!
        ) as any;
        if (
          (!userWeight && !firstPageLessWeightYuxid) ||
          (userWeight && !userWeight.totalWeight && !firstPageLessWeightYuxid)
        ) {
          minTotalWeight = 0;
          firstPageLessWeightYuxid = excludePreviousMembers[i].yxUidStr!;
        } else if (userWeight && minTotalWeight && userWeight.totalWeight < minTotalWeight) {
          minTotalWeight = userWeight?.totalWeight;
          firstPageLessWeightYuxid = excludePreviousMembers[i].yxUidStr!;
        }
      }
      firstPageLessWeightIndex = findIndex(
        firstPageMembers,
        (item) => item.yxUidStr === firstPageLessWeightYuxid
      );
      if (firstPageLessWeightIndex !== -1 && yuxidIndex !== undefined && yuxidIndex !== -1) {
        meeting.updateMemberMap(yuxidIndex, firstPageLessWeightIndex);
        speakWeight.setPreviosusSpeakYuxid(yuxid);
      }
    }
  };
  useEffect(() => {
    const nowBigSpeakYuxid = speakWeight.nowBigSpeakYuxid;
    // console.log('会议的nowBigSpeakYuxid', nowBigSpeakYuxid);
    // console.log('会议的previousSpeakYuxid', speakWeight.previousSpeakYuxid);
    const members = meeting?.sortMembers;
    if (
      nowBigSpeakYuxid &&
      members &&
      !nowSpeakInOnePage(members, nowBigSpeakYuxid) &&
      members.length > 9 &&
      nowBigSpeakYuxid !== speakWeight.previousSpeakYuxid
    ) {
      // 当前yuxid跟之前权重最小的交换
      swapMembersByWeight(nowBigSpeakYuxid);
    }
  }, [speakWeight.nowBigSpeakYuxid, speakWeight.previousSpeakYuxid, meeting?.sortMembers]);

  const startCalc = () => {
    if (calcNowBiggerWeight.current) {
      return;
    }
    calcNowBiggerWeight.current = setInterval(() => {
      speakWeight.calcSpeakBigWeight();
    }, 1000);
  };

  useEffect(() => {
    return () => {
      clearInterval(calcNowBiggerWeight.current);
    };
  }, []);

  startCalc();
};
